(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["custom-popup-2"]) return;
  try {
    
    // set focus when modal is opened
$('#modal-content').on('shown.bs.modal', function () {
    $("#txtname").focus();
});

// show the modal onload
$('#modal-content').modal({
    show: true
});

// everytime the button is pushed, open the modal, and trigger the shown.bs.modal event
$('#openBtn').click(function () {
    $('#modal-content').modal({
        show: true
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-popup"]) return;
  try {
    
    // set focus when modal is opened
$('#modal-content').on('shown.bs.modal', function () {
    $("#txtname").focus();
});

// show the modal onload
$('#modal-content').modal({
    show: true
});

// everytime the button is pushed, open the modal, and trigger the shown.bs.modal event
$('#openBtn').click(function () {
    $('#modal-content').modal({
        show: true
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-facebook-message"] && !window.DesignMode) return;
  try {
    
	jQuery(document).ready(function($) {
		$(document).on('click', '.ss-fb-ms-bottom', function() {
			$('.ss-fb-ms-inner').show();
			$(this).hide();
		})

		$(document).on('click', '.offline_heading', function() {
			$('.ss-fb-ms-inner').hide();
			$('.ss-fb-ms-bottom').show();
		})
	})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-custom"] && !window.DesignMode) return;
  try {
    

jQuery("#testimonial_slider").owlCarousel({

 
    //Autoplay
    autoplay: true,
    autoPlaySpeed: 2000,
    autoPlayTimeout: 2000,
    autoplayHoverPause: true,
 
    // Navigation
    navigation : true,
  	navigationText : "",
    
    scrollPerPage : true,
 
    //Pagination
    pagination : true,
    paginationNumbers: true,  
  
    margin: 20,
    loop: true,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
 
    responsiveClass: true,
    autoHeight: false,

    items : 1,
    responsive : {
              480 : { items : 1  }, 
              768 : { items : 1  }, 
              1024 : { items : 1 }
          }
});

  } catch(e) { console.error(e); }
})();

})();
